import { Injectable } from "@angular/core";
@Injectable()
export class Nav {

  public form: any = {formId: "", title: ""};
  public guide: any = {guideId: "", title: ""};
  public registration: any = {registrationId: "", title: ""};
  public role: any = {roleId: "", title: ""};
  public service: any = {serviceId: "", title: ""};

  public data: any[] = [
    {
      name: "services",
      title: "nav.1_registrations",
      routerLink: "/services",
      icon: "fa fa-globe",
    },
    {
      name: this.service.serviceId,
      title: "nav.1_registrations",
      routerLink: "/services/" + this.service.serviceId,
    },
    {
      name: "registrations",
      title: "nav.2_1_guide",
      routerLink: "/services/" + this.service.serviceId + "/registrations",
      icon: "fa fa-institution",
      background: "icon-bg bg-default",
    },
    {
      name: this.registration.registrationId,
      title: this.registration.title,
      routerLink: "/services/" + this.service.serviceId + "/registrations/" + this.registration.registrationId,
    },
    {
      name: "applicationFile",
      title: "nav.2_2_form",
      icon: "fa fa-file-o",
      background: "icon-bg bg-orange",
    },
    {
      name: "notification",
      title: "nav.2_6_messages",
      icon: "fa fa-file-o",
      background: "icon-bg bg-orange",
    },
    {
      name: "guides",
      title: "nav.2_2_form",
      routerLink: "/services/" + this.service.serviceId + "/guides",
      icon: "fa fa-file-o",
      background: "icon-bg bg-orange",
    },
    {
      name: this.guide.guideId,
      title: this.guide.title,
      routerLink: "/services/" + this.service.serviceId + "/guides/" + this.guide.guideId,

    },
    {
      name: "forms",
      title: "nav.2_3_docs",
      routerLink: "/services/" + this.service.serviceId + "/forms",
      icon: "fa fa-file-o",
      background: "icon-bg bg-warning",
    },
    {
      name: this.form.formId,
      title: this.form.title,
      routerLink: "/services/" + this.service.serviceId + "/forms/" + this.form.formId,
    },
    {
      name: "roles",
      title: "nav.2_4_pay",
      routerLink: "/services/" + this.service.serviceId + "/roles",
      icon: "fa fa-bullhorn",
      background: "icon-bg bg-info",
    },
    {
      name: this.role.roleId,
      title: this.role.title,
      routerLink: "/services/" + this.service.serviceId + "/roles/" + this.role.roleId,
    },
    {
      name: "tables",
      title: "nav.2_5_send",
      routerLink: "/services/" + this.service.serviceId + "/tables",
      icon: "fa-file-fa text-o",
      background: "icon-bg bg-violet",
    },
    {
      name: "crossedTables",
      title: "nav.3_roles",
      routerLink: "/services/" + this.service.serviceId + "/tables",
      icon: "fa fa-table",
      background: "icon-bg bg-primary-light",
    },
    {
      name: "export",
      title: "nav.export",
      routerLink: "/services/" + this.service.serviceId + "/export",
      icon: "fa-file-fa pdf-o",
      background: "icon-bg bg-violet",

    },
  ];

}
